import React from 'react';

import {Formik} from "formik";

const CustomForm = ({children, className, initialValues,formik}) => {
    return (
        <Formik
            initialValues={initialValues}
            // validationSchema={validationSchema}
            enableReinitialize={true}
        >
            <form className={`form ${className}`} onSubmit={formik.handleSubmit}>
                {children}
            </form>
        </Formik>
    );
};

export default CustomForm;
